import Container from 'typedi';
import IHTTPClientAdapter from '../adapters/HTTPClientAdapter/IHTTPClientAdapter';

class SpotRepository {
  httpClientAdapter;
  lastmileApiUrl;
  constructor() {
    this.httpClientAdapter = Container.get(IHTTPClientAdapter);
    this.lastmileApiUrl = Container.get('ENV_LASTMILE_API_URL');
  }
  async getSpots() {
    const clientId = Container.get('clientId');
    const accessToken = Container.get('accessToken');
    const url = `${this.lastmileApiUrl}/api/spot/temporal?withAllTemporal=false`;
    try {
      const config = {
        headers: {
          'id-client': clientId,
          Authorization: `Bearer ${accessToken}`,
        }
      };
      const response = await this.httpClientAdapter.get(url, config);
      return response.data;
    } catch (e) {
      return [];
    }
  }
}

Container.set({ id: SpotRepository, type: SpotRepository });

export default SpotRepository;
